import { render, staticRenderFns } from "./VarietyList.vue?vue&type=template&id=d3b539ea&scoped=true"
import script from "./VarietyList.vue?vue&type=script&lang=js"
export * from "./VarietyList.vue?vue&type=script&lang=js"
import style0 from "./VarietyList.vue?vue&type=style&index=0&id=d3b539ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b539ea",
  null
  
)

export default component.exports